/**
 * <back-in-stock-updater> custom element
 *
 * Listens to the Horizon `variant:update` event (see assets/events.js) and
 * replaces its own innerHTML with the matching wrapper from the variant's
 * pre-rendered HTML — so the back-in-stock form appears/disappears when the
 * shopper switches between in-stock and out-of-stock variants without a refresh.
 *
 * Wrapper renders ALWAYS (even when the variant is in stock) so the JS has
 * a stable mount point. The Liquid snippet decides what (if anything) to
 * render inside it server-side.
 */
class BackInStockUpdater extends HTMLElement {
  connectedCallback() {
    this._handler = this._handleVariantUpdate.bind(this);
    document.addEventListener('variant:update', this._handler);
  }

  disconnectedCallback() {
    document.removeEventListener('variant:update', this._handler);
  }

  _handleVariantUpdate(event) {
    const detail = event && event.detail;
    if (!detail) return;

    const ourProductId = this.dataset.productId;
    const eventProductId = detail.data && detail.data.productId;

    // Multiple products on the same page (e.g. quick view): only respond to ours.
    if (eventProductId && ourProductId && String(eventProductId) !== String(ourProductId)) {
      return;
    }

    const html = detail.data && detail.data.html;
    if (!html || typeof html.querySelector !== 'function') return;

    const newWrapper = html.querySelector(
      `back-in-stock-updater[data-product-id="${ourProductId}"]`
    );

    // If the variant has no rendered wrapper (shouldn't happen — we always render
    // it), bail out. If it has an empty wrapper (variant available), this clears.
    if (!newWrapper) return;

    this.innerHTML = newWrapper.innerHTML;
  }
}

if (!customElements.get('back-in-stock-updater')) {
  customElements.define('back-in-stock-updater', BackInStockUpdater);
}
